import React, { useState, useEffect, useRef } from 'react';
import { database,  auth, storage, signOut } from '../firebase'; // Import database from firebase
import Transactions from './Transactions';
import RedeemMiles from './RedeemMiles';
const handleLogout = async () => {
  try {
    await signOut(auth);
    console.log('User has been logged out');
    // Redirect or update UI as needed
  } catch (error) {
    console.error('Error logging out: ', error);
  }};


const encodeEmail = (email) => {
  return email.replace(/\./g, '_').replace(/@/g, '_');
};

const decodeEmail = (encodedEmail) => {
  return encodedEmail.replace(/_/g, '.').replace(/_/, '@');
};

const formatDiscordUserId = (discordUserId) => {
  return discordUserId.replace(/(\d{4})/g, '$1 ').trim();
};

const MilesAc = ({ user }) => {
  const [balance, setBalance] = useState(0.00);
  const [tier, setTier] = useState('Basic');
  const [nickname, setNickname] = useState('');
  const [discordUserId, setDiscordUserId] = useState('');
  const [cardimage, setcardimage] = useState('');
  const [recipientEmail, setRecipientEmail] = useState('');
  const [amount, setAmount] = useState('');
  const imgRef = useRef(null);

  const [activeDiv, setActiveDiv] = useState(0);
  useEffect(() => {
    if (user) {
      const encodedEmail = encodeEmail(user.email);
      fetchUserData(encodedEmail);
    }
  }, [user]);
  
  const fetchUserData = async (encodedEmail) => {
    try {
      const userSnapshot = await database.ref(`users/${encodedEmail}`).once('value');
      if (userSnapshot.exists()) {
        const userData = userSnapshot.val();
        setBalance(userData.balance);
        setTier(userData.tier);
        setNickname(userData.nickname);
        setDiscordUserId(userData.discordUserId || ''); // Handle blank or undefined discordUserId
        setcardimage(userData.cardimage);
      } else {
        console.error('User data does not exist in the database');
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };


  useEffect(() => {
    if (cardimage && imgRef.current) {
      imgRef.current.src = cardimage; // Dynamically set the src attribute
    }
  }, [cardimage]);

  const handleSendMoney = async () => {
    if (!recipientEmail || !amount) {
      alert('Please provide recipient email and amount.');
      return;
    }

    const senderEmail = encodeEmail(user.email);
    const recipientEmailEncoded = encodeEmail(recipientEmail);
    const amountToSend = parseFloat(amount);

    if (isNaN(amountToSend) || amountToSend <= 0) {
      alert('Invalid amount.');
      return;
    }

    try {
      // Fetch sender data
      const senderSnapshot = await database.ref(`users/${senderEmail}`).once('value');
      if (!senderSnapshot.exists()) {
        throw new Error('Sender not found.');
      }
      const senderData = senderSnapshot.val();

      // Fetch recipient data
      const recipientSnapshot = await database.ref(`users/${recipientEmailEncoded}`).once('value');
      if (!recipientSnapshot.exists()) {
        throw new Error('Recipient not found.');
      }
      const recipientData = recipientSnapshot.val();

      if (senderData.balance < amountToSend) {
        throw new Error('Insufficient balance.');
      }

      // Update balances
      const newSenderBalance = senderData.balance - amountToSend;
      const newRecipientBalance = (recipientData.balance || 0) + amountToSend;

      // Perform updates
      await database.ref(`users/${senderEmail}`).update({ balance: newSenderBalance });
      await database.ref(`users/${recipientEmailEncoded}`).update({ balance: newRecipientBalance });

      // Record transaction
      const transactionId = database.ref('transactions').push().key;
      await database.ref(`transactions/${transactionId}`).set({
        from: senderEmail,
        to: recipientEmailEncoded,
        amount: amountToSend,
        timestamp: new Date().toISOString(),
      });

      // Update UI
      setBalance(newSenderBalance);
      setRecipientEmail('');
      setAmount('');
      alert(`Sent $${amountToSend.toFixed(2)} to ${recipientEmail}.`);

    } catch (error) {
      console.error('Transaction Error:', error.message);
      alert('Transaction failed: ' + error.message);
    }
  };

  return (
    <div>
      {user && (
        <>

        <div className="bannera bannera--black header-with-tabs">
        <div className="containera">
          <div className="bannera-img__txt">
            <div className="bannera--black__info">
              <div className="pointsa">EMI No. {formatDiscordUserId(discordUserId)}</div>
              <strong className="namea">Welcome, {nickname}</strong>
            </div>
            <div className="bannera--black__status">
              <div className="statusa">
                <span className="status-namea"> </span>
              </div>
            </div>
          </div>
        </div>
        <div className="status-bar-korua" />
      </div>

      <button className="logoutoverlaybtn" onClick={handleLogout}>
  Logout
</button>
 
      <div className="money-transfer-container">
        <div
          className="user-benefits content-box content-box--border"
          style={{
            boxSizing: "border-box",
            border: "1px solid rgb(228, 228, 231)",
            borderRadius: "8px",
            padding: "1.17647rem",
            boxShadow: "none",
            paddingLeft: "0px",
            paddingRight: "0px",
          }}
        >
          <div
            className="user-benefits__tier"
            style={{
              boxSizing: "border-box",
              padding: "0px 1.17647rem 1.17647rem",
              borderBottom: "1px solid rgb(229, 229, 229)",
              textAlign: "center",
              marginBottom: "1.17647rem",
            }}
          >
            <div
              className="user-benefits__img"
              style={{ boxSizing: "border-box", marginBottom: "0.55rem" }}
            >
              <img
                ref={imgRef}
                style={{
                  boxSizing: "border-box",
                  borderStyle: "none",
                  verticalAlign: "middle",
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
            </div>
            <div
              className="user-benefits__info"
              style={{ boxSizing: "border-box" }}
            >
              <div
                className="unit-g"
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <strong
                  className="unit-g__text"
                  style={{
                    boxSizing: "border-box",
                    fontSize: "1.29412rem",
                    color: "rgb(0, 0, 0)",
                    fontWeight: 600,
                  }}
                >E${balance.toFixed(2)}
                </strong>
              </div>
              <span
                style={{
                  boxSizing: "border-box",
                  fontSize: "0.882353rem",
                  color: "rgb(118, 118, 118)",
                }}
              >
                EMI Miles™ Balance
                <br />Tier: {tier}
              </span>
            </div>
          </div><div>
          <div className="container-tx">
      <div className="button-container-tx">
        <div className="button-wrapper-tx">
          <button onClick={() => setActiveDiv(0)} className={`circle-button-tx ${activeDiv === 0 ? 'active-tx' : ''}`}>
          <svg fill="#000000" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" d="M21,4 C21.5522847,4 22,3.55228475 22,3 C22,2.44771525 21.5522847,2 21,2 L3,2 C2.44771525,2 2,2.44771525 2,3 C2,3.55228475 2.44771525,4 3,4 L21,4 Z M12,6 L11.918,6.004 L11.7992742,6.02024007 L11.6878575,6.04973809 L11.5767785,6.09367336 L11.4792912,6.14599545 L11.4048407,6.19631351 L11.2928932,6.29289322 L7.29289322,10.2928932 C6.90236893,10.6834175 6.90236893,11.3165825 7.29289322,11.7071068 C7.65337718,12.0675907 8.22060824,12.0953203 8.61289944,11.7902954 L8.70710678,11.7071068 L11,9.415 L11,21 C11,21.5522847 11.4477153,22 12,22 C12.5522847,22 13,21.5522847 13,21 L13,9.415 L15.2928932,11.7071068 C15.6533772,12.0675907 16.2206082,12.0953203 16.6128994,11.7902954 L16.7071068,11.7071068 C17.0675907,11.3466228 17.0953203,10.7793918 16.7902954,10.3871006 L16.7071068,10.2928932 L12.7071068,6.29289322 L12.663147,6.2514958 L12.5953066,6.19633458 L12.4840621,6.12467117 L12.4230991,6.09365378 L12.3416504,6.05988586 L12.265993,6.03584514 L12.1174742,6.00683422 L12,6 Z"/>
</svg>
          </button>
          <p>Send</p>
        </div>
        <div className="button-wrapper-tx">
          <button onClick={() => setActiveDiv(1)} className={`circle-button-tx ${activeDiv === 1 ? 'active-tx' : ''}`}>
          <svg fill="#000000" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" d="M21,20 C21.5522847,20 22,20.4477153 22,21 C22,21.5522847 21.5522847,22 21,22 L3,22 C2.44771525,22 2,21.5522847 2,21 C2,20.4477153 2.44771525,20 3,20 L21,20 Z M12,18 L11.918,17.996 L11.7992742,17.9797599 L11.7992742,17.9797599 L11.6878575,17.9502619 L11.6878575,17.9502619 L11.5767785,17.9063266 L11.4792912,17.8540045 L11.4792912,17.8540045 L11.4048407,17.8036865 L11.4048407,17.8036865 L11.2928932,17.7071068 L7.29289322,13.7071068 C6.90236893,13.3165825 6.90236893,12.6834175 7.29289322,12.2928932 C7.65337718,11.9324093 8.22060824,11.9046797 8.61289944,12.2097046 L8.70710678,12.2928932 L11,14.585 L11,3 C11,2.44771525 11.4477153,2 12,2 C12.5522847,2 13,2.44771525 13,3 L13,14.585 L15.2928932,12.2928932 C15.6533772,11.9324093 16.2206082,11.9046797 16.6128994,12.2097046 L16.7071068,12.2928932 C17.0675907,12.6533772 17.0953203,13.2206082 16.7902954,13.6128994 L16.7071068,13.7071068 L12.7071068,17.7071068 L12.663147,17.7485042 L12.663147,17.7485042 L12.5953066,17.8036654 L12.5953066,17.8036654 L12.4840621,17.8753288 L12.4230991,17.9063462 L12.4230991,17.9063462 L12.3416504,17.9401141 L12.3416504,17.9401141 L12.265993,17.9641549 L12.265993,17.9641549 L12.1174742,17.9931658 L12.1174742,17.9931658 L12,18 Z"/>
</svg>
          </button>
          <p>Receive</p>
        </div>
        <div className="button-wrapper-tx">
          <button onClick={() => setActiveDiv(2)} className={`circle-button-tx ${activeDiv === 2 ? 'active-tx' : ''}`}>
          <svg fill="#000000" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M17.0020048,13 C17.5542895,13 18.0020048,13.4477153 18.0020048,14 C18.0020048,14.5128358 17.6159646,14.9355072 17.1186259,14.9932723 L17.0020048,15 L5.41700475,15 L8.70911154,18.2928932 C9.0695955,18.6533772 9.09732503,19.2206082 8.79230014,19.6128994 L8.70911154,19.7071068 C8.34862757,20.0675907 7.78139652,20.0953203 7.38910531,19.7902954 L7.29489797,19.7071068 L2.29489797,14.7071068 C1.69232289,14.1045317 2.07433707,13.0928192 2.88837381,13.0059833 L3.00200475,13 L17.0020048,13 Z M16.6128994,4.20970461 L16.7071068,4.29289322 L21.7071068,9.29289322 C22.3096819,9.8954683 21.9276677,10.9071808 21.1136309,10.9940167 L21,11 L7,11 C6.44771525,11 6,10.5522847 6,10 C6,9.48716416 6.38604019,9.06449284 6.88337887,9.00672773 L7,9 L18.585,9 L15.2928932,5.70710678 C14.9324093,5.34662282 14.9046797,4.77939176 15.2097046,4.38710056 L15.2928932,4.29289322 C15.6533772,3.93240926 16.2206082,3.90467972 16.6128994,4.20970461 Z"/>
</svg>
          </button>
          <p>Transactions</p>
        </div>
        <div className="button-wrapper-tx">
          <button onClick={() => setActiveDiv(3)} className={`circle-button-tx ${activeDiv === 3 ? 'active-tx' : ''}`}>
          <svg fill="#000000" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" d="M12,19.7981496 L20.4452998,14.1679497 C20.9048285,13.8615972 21.5256978,13.9857711 21.8320503,14.4452998 C22.1165204,14.872005 22.0297714,15.4378254 21.648003,15.7617627 L21.5547002,15.8320503 L12.5547002,21.8320503 C12.2561229,22.0311018 11.8771884,22.0532186 11.560754,21.8984008 L11.4452998,21.8320503 L2.4452998,15.8320503 C1.98577112,15.5256978 1.86159725,14.9048285 2.16794971,14.4452998 C2.45241985,14.0185946 3.00808057,13.8810474 3.45393368,14.1088578 L3.5547002,14.1679497 L12,19.7981496 L20.4452998,14.1679497 L12,19.7981496 Z M12.5547002,2.16794971 L21.5547002,8.16794971 C22.1484333,8.56377175 22.1484333,9.43622825 21.5547002,9.83205029 L12.5547002,15.8320503 C12.2188008,16.0559832 11.7811992,16.0559832 11.4452998,15.8320503 L2.4452998,9.83205029 C1.85156673,9.43622825 1.85156673,8.56377175 2.4452998,8.16794971 L11.4452998,2.16794971 C11.7811992,1.94401676 12.2188008,1.94401676 12.5547002,2.16794971 Z M12,4.20185043 L4.80277564,9 L12,13.7981496 L19.1972244,9 L12,4.20185043 Z"/>
</svg>
          </button>
          <p>Redeem</p>
        </div>
        <div className="button-wrapper-tx">
          <button onClick={() => setActiveDiv(4)} className={`circle-button-tx ${activeDiv === 4 ? 'active-tx' : ''}`}>
          <svg fill="#000000"  width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" d="M7,8.5 C7,6.29584229 8.73751171,4.50141712 11.0052145,4.08920503 L11.0011675,4.04546297 L11.0011675,4.04546297 L11,3 C11,2.44771525 11.4477153,2 12,2 C12.5522847,2 13,2.44771525 13,3 L13,4 L12.9957846,4.08938673 C15.2629986,4.5019442 17,6.29616601 17,8.5 C17,9.05228475 16.5522847,9.5 16,9.5 C15.4871642,9.5 15.0644928,9.11395981 15.0067277,8.61662113 L15,8.5 C15,7.15119434 13.6843493,6 12,6 C10.3156507,6 9,7.15119434 9,8.5 C9,9.79884989 10.2199998,10.9144553 11.8144155,10.995311 L12,11 C14.7339287,11 17,12.9828124 17,15.5 C17,17.7022154 15.2655491,19.4954201 13.0007791,19.909702 L13,21 C13,21.5522847 12.5522847,22 12,22 C11.4477153,22 11,21.5522847 11,21 L11.0002197,19.9098846 C8.73496086,19.4959473 7,17.7025391 7,15.5 C7,14.9477153 7.44771525,14.5 8,14.5 C8.55228475,14.5 9,14.9477153 9,15.5 C9,16.8488057 10.3156507,18 12,18 C13.6843493,18 15,16.8488057 15,15.5 C15,14.2011501 13.7800002,13.0855447 12.1855845,13.004689 L12,13 C9.26607132,13 7,11.0171876 7,8.5 Z"/>
</svg>
          </button>
          <p>Payout</p>
        </div>
        <div className="button-wrapper-tx">
          <button onClick={() => setActiveDiv(5)} className={`circle-button-tx ${activeDiv === 5 ? 'active-tx' : ''}`}>
          <svg fill="#000000" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" d="M12,4 C12.5522847,4 13,4.44771525 13,5 L13,11 L19,11 C19.5522847,11 20,11.4477153 20,12 C20,12.5522847 19.5522847,13 19,13 L13,13 L13,19 C13,19.5522847 12.5522847,20 12,20 C11.4477153,20 11,19.5522847 11,19 L11,13 L5,13 C4.44771525,13 4,12.5522847 4,12 C4,11.4477153 4.44771525,11 5,11 L11,11 L11,5 C11,4.44771525 11.4477153,4 12,4 Z"/>
</svg>
          </button>
          <p>Top-up</p>
        </div>
      </div></div></div>
          <ul
            className="user-benefits__utils"
            style={{
              boxSizing: "border-box",
              margin: "0px",
              listStyle: "none",
              marginTop: "0px",
              marginBottom: "0px",
              padding: "0px 0.55rem",
            }}
          >
            <li
              className="item"
              style={{
                boxSizing: "border-box",
                margin: "0px",
                padding: "0px",
                listStyle: "none",
                marginBottom: "0px",
              }}
            >
              <a
                href="https://docs.google.com/spreadsheets/d/1czFlcASY-XUIdApCbDLURhn_gZ13zWwRLSKGvi73jkw/edit?usp=sharing"
                style={{
                  boxSizing: "border-box",
                  backgroundColor: "transparent",
                  transition: "0.3s",
                  textDecoration: "none",
                  padding: "0.55rem",
                  display: "flex",
                  alignItems: "center",
                  color: "rgb(0, 0, 0)",
                }}
              >
                <i
                  className="icon"
                  style={{
                    boxSizing: "border-box",
                    position: "relative",
                    fontStyle: "normal",
                    width: "24px",
                    display: "flex",
                    marginRight: "0.55rem",
                  }}
                >
                  <svg
                    height="16"
                    width="20"
                    fill="none"
                    viewBox="0 0 20 16"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      boxSizing: "border-box",
                      overflow: "hidden",
                      verticalAlign: "middle",
                    }}
                  >
                    <path
                      d="M20 2V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H2C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2ZM2 4H18V2H2V4ZM2 8V14H18V8H2Z"
                      style={{ boxSizing: "border-box", fill: "rgb(0, 0, 0)" }}
                    />
                  </svg>
                </i>
                <span
                  style={{
                    boxSizing: "border-box",
                    transition: "0.2s",
                    position: "relative",
                    display: "inline-block",
                  }}
                >
                  About Membership
                </span>
                <i
                  className="arrow d-block d-md-none"
                  style={{
                    boxSizing: "border-box",
                    position: "relative",
                    fontStyle: "normal",
                    marginLeft: "auto",
                    display: "none",
                  }}
                >
                  <img
                    src="https://www.airnewzealand.co.nz/airpoints-account/airpoints/images/icons/icon-arw-link.svg"
                    style={{
                      boxSizing: "border-box",
                      borderStyle: "none",
                      verticalAlign: "middle",
                      maxWidth: "100%",
                      height: "auto",
                    }}
                  />
                </i>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div style={{ display: activeDiv === 0 ? 'block' : 'none' }}>
          <div className="money-transfer-container">
  <p className="nickname">My Address: {user.email}</p>
  <div className="send-money-section">
    <h3 className="send-money-title">Send Money</h3>
    <div className="input-field">
      <input
        type="email"
        className="recipient-email"
        placeholder="Recipient Email"
        value={recipientEmail}
        onChange={(e) => setRecipientEmail(e.target.value)}
      />
      <input
        type="number"
        className="amount"
        placeholder="Amount"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        min="0"
      />
    </div>
    <button className="send-button" onClick={handleSendMoney}>Send</button>
  </div><div/></div></div>
        <div style={{ display: activeDiv === 1 ? 'block' : 'none' }}>
          <div className="money-transfer-container">
  <p className="nickname">My Address: {user.email}</p>
    </div></div>
        <div style={{ display: activeDiv === 2 ? 'block' : 'none' }}><Transactions userId={user.email} /></div>
        <div style={{ display: activeDiv === 3 ? 'block' : 'none' }}>
        <RedeemMiles userId={user.email} /></div>
        <div style={{ display: activeDiv === 4 ? 'block' : 'none' }}><div className="money-transfer-container"><button className='send-button'><a href='https://forms.gle/XycTNYLeDR6WV7Wd8' target='blank' style={{textDecoration:'none', textAlign:'center', color: '#FFFFFF', fontFamily:'FoundryContextW03Demi'}}
        >Payout Request Form</a></button></div></div>
        <div style={{ display: activeDiv === 5 ? 'block' : 'none' }}><div className="money-transfer-container"><button className='send-button'><a href='https://forms.gle/d9SitvezrPGVvBzx6' target='blank' style={{textDecoration:'none', textAlign:'center', color: '#FFFFFF', fontFamily:'FoundryContextW03Demi'}}
        >Top-up Form</a></button></div></div>

        </>
      )}
    </div>
  );
};

export default MilesAc;
